export const _getStartEndColumns = (gridColumn) =>
    gridColumn.split("/").map((d) => parseInt(d.trim()));